import { defineComponent as t, openBlock as d, createBlock as n, unref as r, mergeProps as c, withCtx as p, createElementVNode as e } from "vue";
import { RevIcon as i } from "@ds/components/Icon";
const f = /* @__PURE__ */ t({
  name: "IconReassuranceLockFilled",
  __name: "IconReassuranceLockFilled",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(a) {
    const o = a;
    return (s, l) => (d(), n(r(i), c(o, { "view-box": "0 0 48 48" }), {
      default: p(() => [...l[0] || (l[0] = [
        e("g", { "clip-path": "url(#118e1823-bc57-4de7-a523-b4126953d9b8a)" }, [
          e("path", { d: "M33.16 15.07a6.379 6.379 0 1 0-12.54-2.34l-.87 4.61 12.55 2.34.86-4.61" }),
          e("path", {
            "fill-rule": "evenodd",
            d: "m34.49 21.11-17.37-3.25a3.7 3.7 0 0 0-.66-.06A3.57 3.57 0 0 0 13 20.71L10.66 33a3.57 3.57 0 0 0 2.85 4.16l17.37 3.25A3.57 3.57 0 0 0 35 37.57l2.3-12.3a3.57 3.57 0 0 0-2.81-4.16m-11.13 5.12c.16-.9.66-1.57 1.09-1.48s.66.87.49 1.77-.66 1.57-1.09 1.49-.66-.88-.49-1.78m4.67 7a8.5 8.5 0 0 1-2.76 0 8.4 8.4 0 0 1-3.8-1.73 8 8 0 0 1-1-1A7.1 7.1 0 0 1 19.1 28a.35.35 0 0 1 .13-.38.34.34 0 0 1 .46.09 14 14 0 0 0 1.58 2 9.4 9.4 0 0 0 1.93 1.52 9.55 9.55 0 0 0 4.8 1.29.33.33 0 1 1 .05.66l-.02.05m0-4.53c-.44 0-.77-.78-.73-1.69s.43-1.64.88-1.63.77.78.73 1.7-.43 1.59-.91 1.57l.03.05",
            "clip-rule": "evenodd"
          }),
          e("path", {
            "fill-rule": "evenodd",
            d: "M10.666 4.045a24 24 0 1 1 26.668 39.91 24 24 0 0 1-26.668-39.91M36 37.75l2.33-12.29a4.58 4.58 0 0 0-3.63-5.33l-1.39-.26.87-4.62a7.39 7.39 0 0 0-14.52-2.71l-.86 4.61-1.47-.27A4.59 4.59 0 0 0 12 20.53l-2.33 12.3a4.59 4.59 0 0 0 3.66 5.33l17.34 3.25a5 5 0 0 0 .84.07 4.5 4.5 0 0 0 2.58-.8A4.6 4.6 0 0 0 36 37.75",
            "clip-rule": "evenodd"
          })
        ], -1),
        e("defs", null, [
          e("clipPath", { id: "118e1823-bc57-4de7-a523-b4126953d9b8a" }, [
            e("path", { d: "M0 0h48v48H0z" })
          ])
        ], -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
